<div class='header'>
  <h1>COUNTDOWN</h1>
</div>
<div class='countdown-container'>
  <div><p class='title'>Days</p><p class="timer">{{days}}</p></div>
  <div><p class='title'>Hours</p><p class="timer">{{hours}}</p></div>
  <div><p class='title'>Minutes</p><p class="timer">{{minutes}}</p></div>
  <div><p class='title'>Seconds</p><p class="timer">{{seconds}}</p></div>
</div>
